import appConfig from 'app-config'

const url = appConfig.url.replace(/\/$/, '') // 誤って末尾スラッシュが付与されていた場合の対策

// is_draft
const stateList = {
  0: '公開',
  1: '下書き'
}
const announcementStateList = {
  0: '公開中',
  1: '下書き',
  2: '公開終了',
  3: '予約'
}

const replyStateList = {
  0: '未読',
  1: '既読',
  2: '返信済'
}

// ポートフォリオの is_show_career
const isShowStateList = {
  0: '表示しない',
  1: '表示する'
}

// ポートフォリオの is_stoppped
const isStoppedStateList = {
  0: '公開中',
  1: '停止中'
}

// ポートフォリオの profile_items
const profileItemsList = {
  address_prefecture: '住所(都道府県)',
  birth_year: '生まれ年',
  birth_month: '生まれ月'
}

const apiErrorTypes = {
  0: 'データの読み込み中です。',
  400: '不正なリクエストを検出しました。',
  401: 'ログイン情報の認証に失敗しました。再度ログインしてください。',
  403: 'このアカウントからはこの情報にアクセス出来ません。',
  404: 'データが見つかりませんでした。',
  405: '不正なリクエストを検出しました。',
  422: 'リクエストに問題がありました。内容をご確認ください。',
  429: '過剰なリクエストが検出されました。',
  500: 'サーバで問題が発生しました。',
  503: '現在このサービスは利用出来ません。',
  999: 'エラーが発生しました。' // その他エラー
}

const vueWidth = {
  sm: 600,
  md: 960,
  lg: 1264,
  xl: 1904
}

export default {
  apiUrl: url + '/api/',
  stateList: stateList,
  replyStateList: replyStateList,
  announcementStateList: announcementStateList,
  isShowStateList: isShowStateList,
  isStoppedStateList: isStoppedStateList,
  profileItemsList: profileItemsList,
  apiErrorTypes: apiErrorTypes,
  vueWidth: vueWidth,
  logo: appConfig.logo,
  favicon: appConfig.favicon
}
